module.exports = __webpack_public_path__ + "media/promo/hochland/images/top_m-e02915e1cadeadfd129fffcbdefe2275.png";